import { memo } from 'react'

import { copy } from '~/modules/lunya'
import { ValueField } from '~/shared/ui'

import type { BirthCityFieldProps } from './types'

/** Город рождения — необязательное поле, 54px `surface-alt` (спека 02 §A2). */
export const BirthCityField = memo(function BirthCityField(props: BirthCityFieldProps) {
  const { value, isActive = false, onPress } = props

  return (
    <ValueField
      label={copy.onb.a2.city}
      value={value}
      iconName='pin'
      isActive={isActive}
      onPress={onPress}
    />
  )
})
